document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".yv-product-grid-quickview");

  buttons.forEach((btn) => {
    btn.addEventListener("click", () => {
      if (typeof BSS_B2B === "object") {
        setTimeout(() => {
          document.dispatchEvent(new Event("bss_b2b:QuickviewLoaded"))
        }, 1000);
      }
    });
  });
});

if (typeof BSS_B2B) {
  document.addEventListener("DOMContentLoaded", function () {
    const target = document.body;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === "class") {
          if (document.body.classList.contains("side_Drawer_open")) {
              setTimeout(() =>{
                BSS_B2B?.observer?.cartSubject?.notifyObserver('CartMutate', 'CartPriceMutate');
                BSS_B2B?.te?.utils?.init();
                BSS_B2B.observer.cartSubject.listenCartCheckout();
              }, 500)
              
          }
        }
      });
    });

    observer.observe(target, {
      attributes: true,
      attributeFilter: ["class"]
    });
  });
}